function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { getProductTypeById } from '@finect/front-resources/Products';
export const MAX_PRODUCTS = 5;
export function comparison() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    products: [],
    funds: [],
    dialog: {
      open: false,
      index: 0
    },
    comparisonsDialog: {
      open: false
    },
    userComparisons: {
      models: [],
      fetching: false,
      fetched: false
    },
    drawerComparison: {
      selectedProducts: [],
      productsType: null
    }
  };
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case 'COMPARISON_ADD_FUND':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          funds: [...state.funds, action.fund]
        });
      }
    case 'COMPARISON_SET_FUNDS':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          funds: [...action.funds]
        });
      }
    case 'COMPARISON_CLEAR_FUNDS':
      {
        const newState = _objectSpread({}, state);
        newState.funds = [];
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'COMPARISON_OPEN_DIALOG':
      {
        const newState = _objectSpread({}, state);
        newState.dialog.open = true;
        newState.dialog.index = 2;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'COMPARISON_CLOSE_DIALOG':
      {
        const newState = _objectSpread({}, state);
        newState.dialog.open = false;
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'COMPARISON_REMOVE_PRODUCT':
      {
        const newState = _objectSpread({}, state);
        newState.funds = state.funds.filter(product => product.id !== action.product.id);
        return _objectSpread(_objectSpread({}, state), newState);
      }
    case 'COMPARISON_SET_USER_COMPARISONS_FETCHING_STATUS':
      {
        const userComparisons = _objectSpread({}, state.userComparisons);
        userComparisons.fetching = Boolean(action.fetching);
        userComparisons.fetched = Boolean(action.fetched);
        return _objectSpread(_objectSpread({}, state), {
          userComparisons
        });
      }
    case 'COMPARISON_SET_USER_COMPARISONS':
      {
        const newUserComparisons = _objectSpread({}, state.userComparisons);
        newUserComparisons.models = [...action.sessions];
        newUserComparisons.fetching = false;
        newUserComparisons.fetched = true;
        return _objectSpread(_objectSpread({}, state), {
          userComparisons: newUserComparisons
        });
      }
    case 'COMPARISON_SET_USER_COMPARISONS_DIALOG':
      {
        const comparisonsDialog = _objectSpread({}, state.comparisonsDialog);
        comparisonsDialog.open = action.open;
        return _objectSpread(_objectSpread({}, state), {
          comparisonsDialog
        });
      }
    case 'COMPARISON_SET_PRODUCTS':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          products: [...action.products]
        });
      }
    case 'DRAWER_COMPARISON_SET_PRODUCT':
      {
        const newDrawerComparison = state.drawerComparison;
        const newSelectedComparison = newDrawerComparison.selectedProducts.find(item => item.entity.id === action.product.entity.id) ? newDrawerComparison.selectedProducts.filter(item => item.entity.id !== action.product.entity.id) : [...newDrawerComparison.selectedProducts, ...[action.product]];
        const newProductsTypeComparison = newSelectedComparison.length ? getProductTypeById(action.product.subtype) : null;
        if (!(newSelectedComparison.length <= MAX_PRODUCTS)) {
          return _objectSpread({}, state);
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          drawerComparison: {
            selectedProducts: newSelectedComparison,
            productsType: newProductsTypeComparison
          }
        });
      }
    case 'DRAWER_COMPARISON_SET_EMPTY':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          drawerComparison: {
            selectedProducts: [],
            productsType: null
          }
        });
      }
    default:
      return state;
  }
}